import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {CurrentUserService} from "../../core/services/user.service";
import {inject} from "@angular/core";

const dataMap: Record<string, UserRightsCreateType> = {
  criterion: 'criterion',
  department: 'department',
  facility: 'facility',
  grade: 'grade',
  ['index-entity']: 'indexentity',
  ['index-ias']: 'indexiasvalue',
  ['index-list-value']: 'indexlistvalue',
  indicators: 'indicator',
  landmarks: 'landmark',
  group: 'org_group',
  organization: 'ref_organization',
  users: 'useraccount'
};
export const canCreateResolver: ResolveFn<any> = async(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, service: CurrentUserService = inject(CurrentUserService)) => {
  let createRight = service.value?.rights?.create
  if (createRight===undefined){
    const data = await service.awaitingFetchUser()
    createRight = data?.rights?.create
    if (createRight===undefined) return false;
  }
  console.log('url',route.url[0].path, dataMap[route.url[0].path])
  return createRight[dataMap[route.url[0].path]];
};
